/*
  *******************
      注册全局组件
  *******************
*/
import Vue from 'vue'

import Layout from '~/components/layout'
import LayoutSidebar from '~/components/layout/sidebar'
import LayoutTop from '~/components/layout/top'
import LayoutMain from '~/components/layout/main'

import pageHeader from '~/components/page-header/'

Vue.component('Layout', Layout)
Vue.component('LayoutSidebar', LayoutSidebar)
Vue.component('LayoutTop', LayoutTop)
Vue.component('LayoutMain', LayoutMain)

Vue.component('pageHeader', pageHeader)



// WEBPACK FOOTER //
// ./src/utils/components.js